import params from '../../config/params';

export default {
    isCloseToStore: driver => !!driver._returningInfo && driver._returningInfo.distance < params.isCloseToStoreDistance,
};



// WEBPACK FOOTER //
// ./src/script/utils/driver.js